var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTelephoneExchange = function SvgTelephoneExchange(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#004ABC",
    clipPath: "url(#telephone-exchange_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.422 17.805h-2.844V9.492H7.356V7.356h9.288v2.136h-3.222z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.658 7.356H7.356v1.16l.975.976h2.247v4.6l1.177-1.176 1.667 1.667V12.12l-.436-.436.436-.435V9.492h1.756l1.466-1.466v-.67h-1.792l-3.097 3.097z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.55 3.872A2.322 2.322 0 0 1 3.872 1.55h16.256a2.322 2.322 0 0 1 2.322 2.322v16.256a2.322 2.322 0 0 1-2.322 2.322H3.872a2.322 2.322 0 0 1-2.322-2.322zm5.947 2.322L5.174 3.872h13.161l-2.322 2.322h1.792v.67l2.323-2.321v14.283l-5.545-5.545v2.463l4.384 4.384H4.543l4.874-4.875V12.79l-5.545 5.545V5.033l2.323 2.323V6.194z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "telephone-exchange_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1.55 1.55h20.9v20.9H1.55z"
  })))));
};
export default SvgTelephoneExchange;